
export const TEMPLATE_TYPE_TASK = "Task";
export const TEMPLATE_TYPE_OBSERVATION = "Observation";
export const TEMPLATE_TYPE_EX_TASK = "Execution";
export const TEMPLATE_TYPE_GENERAL = "Assignment Level";
export const TEMPLATE_TYPE_FOLLOWUP = "Follow Up";
export const TEMPLATE_TYPE_AUDITEE_COMMENT = "Response";
export const OBSERVATION_MAX_ID = 6;
export const EXEC_TASK_MAX_ID = 2;
export const GENERAL_MAX_ID = 1;
export const FOLLOW_UP_MAX_ID = 1;
export const RESPONSE_MAX_ID = 3;

export const FIELD_TYPES_ARR = [
    {value:"Text"},
    {value:"Date"},
    {value:"Dropdown"},
    {value:"Dropdown Multiselect"},
    {value:"Table"}
    
];
export const FIELD_TASK_TYPES_ARR = [
    {value:"Text"},
    {value:"Date"},
    {value:"Dropdown"},
    {value:"Dropdown Multiselect"},
    {value:"Table"},
    {value:"Framework"}
];
export const OBSERVATION_FIELD_TYPES_ARR = [
    {value:"Text"},
    {value:"Date"},
    {value:"Dropdown"},
    {value:"Dropdown Multiselect"},
    {value:"Table"},
    {value:"Numeric"},
    {value:"Master"}
];
export const EX_TASK_FIELD_TYPES_ARR = [
    {value:"Text"},
    {value:"Date"},
    {value:"Single-select"},
    {value:"Multi-select"},
    {value:"Table"},
    {value:"Numeric"},
    {value:"Yes/No"},
    {value:"Score"},
    {value:"Value Addition"},
    {value:"ISO"}
];
export const FIELD_TYPES_ARR_LEFT = [
    {value:"Single-select"},
    {value:"Multi-select"},
    {value:"Weighted Score"},
    {value:"Maximum Score"},
    {value:"Value Addition"}
];
export const FOLLOWUP_FIELD_TYPES_ARR = [
    {value:"Text"},
    {value:"Date"},
    {value:"Dropdown"},
    {value:"Dropdown Multiselect"},
]
export const FIELD_TYPES_AUDITEE_COMMENT = [
    {value:"Text"},
    {value:"Date"},
    {value:"Dropdown"},
    {value:"Dropdown Multiselect"},
    {value:"Table"},
    {value:"Open/Closed"}
];
export const FIELD_TYPE_YES_NO_DD_VALUE_ARR = [
    {
        value: "Yes",
        description: "Yes",
        valueNdesc: "",
    },
    {
        value: "No",
        description: "No",
        valueNdesc: "",
    },
    {
        value: "N/A",
        description: "N/A",
        valueNdesc: "",
    }
];
export const FIELD_TYPE_OPEN_CLOSED_DD_VALUE_ARR = [
    {
        value: "Open",
        description: "Open",
        valueNdesc: ""
    },
    {
        value: "Closed",
        description: "Closed",
        valueNdesc: ""
    }
];
export const MASTER_TYPE_EMPLOYEE = "Employee";
export const MASTER_TYPE_RISK_IMPACT = "Risk/Impact";
export const MASTER_TYPE_ARR = [
    {value:"Designation"},
    {value:"Employee"},
    {value:"Risk/Impact"}
];
export const STANDARD_FIELD_ARR = [
    {value:"Observation Heading"},
    {value:"Detailed Observation"},
    {value:"Risk / Impact"},
    {value:"Value Addition"},
    {value:"Root Cause Analysis"},
    {value:"Suggestions"},
    {value:"Executive Summary"},
    {value:"Responsibility"},
    {value:"Quantification"},
    {value:"Findings"}
];
export const RESPONSE_STANDARD_FIELD_ARR = [
    {value:"Response"},
    {value:"Corrective Action"},
    {value:"Preventive Action"},
    {value:"Corrective & Preventive Action"},
    {value:"Root Cause Analysis"},
    {value:"Target Date"},
    {value:"Responsibility"}
];
export const GENERAL_FIELD_TYPES_ARR = [
    {value:"Text"},
    {value:"Date"},
    {value:"Dropdown"},
    {value:"Dropdown Multiselect"},
    {value:"Table"},
    {value:"Master"}
];
export const CATEGORY = [
    {value: "Compliance"},
    {value: "Observation"},
    {value: "Observation - Major"},
    {value: "Observation - Minor"},
    {value: "Observation - Positive"},
    {value: "Non Conformity - Major"},
    {value: "Non Conformity - Minor"},
    {value: "Previous Non Conformity"},
]
export const getMaxScoreArray = (minScore,maxScore) => {
    let maxScoreArray = [];
    for(let i=minScore;i<=maxScore; i++){
        maxScoreArray.push({
            label:i
        })
    }

    return maxScoreArray;
}
export const FIELD_TYPE_TEXT = "Text";
export const FIELD_TYPE_DATE = "Date";
export const FIELD_TYPE_DROPDOWN = "Dropdown";
export const FIELD_TYPE_DROPDOWN_MULTI = "Dropdown Multiselect";
export const FIELD_TYPE_TABLE = "Table";
export const FIELD_TYPE_SINGLE_SELECT = "Single-select";
export const FIELD_TYPE_MULTI_SELECT = "Multi-select";
export const FIELD_TYPE_NUMERIC = "Numeric";
export const FIELD_TYPE_YES_NO = "Yes/No";
export const FIELD_TYPE_VALUE_ADDITION = "Value Addition";
export const FIELD_TYPE_SCORE = "Score";
export const FIELD_TYPE_WEIGHTED_SCORE = "Weighted Score";
export const FIELD_TYPE_MAXIMUM_SCORE = "Maximum Score";
export const FIELD_TYPE_FRAMEWORK = "Framework";
export const FIELD_TYPE_ISO = "ISO";
export const FIELD_TYPE_MASTER = "Master";
export const FIELD_TYPE_OPEN_CLOSED = "Open/Closed";

export const FIELD_TYPE_DD_VALUE_ARR = [
    {value:"",description:"", valueNdesc:""},
    {value:"",description:"", valueNdesc:""},
];

export const ADD_FIELD_DD_ARR = [
    {
        value:"Dropdown", 
    },
    {
        value:"Dropdown Multiselect", 
    }
];

export const OBSERVATION_FIELDS = [
    {
        fieldId:"1",
        fieldName: "Observation Heading",
        fieldType: "Text",
        isNotReqSelected: "Y",
        isMandatorySelected: "N",
        placeholderValue: "Enter Observation Heading",
        canBeDeleted: "N",
        orderPos:1,
        fieldStatus:"Created",
        fieldStatus_new:"Created"
    },
    {
        fieldId:"2",
        fieldName: "Observation Details",
        fieldType: "Text",
        isNotReqSelected: "N",
        isMandatorySelected: "Y",
        placeholderValue: "Enter Observation Details",
        canBeDeleted: "N",
        orderPos:2,
        fieldStatus:"Created",
        fieldStatus_new:"Created"
    },
    {
        fieldId:"3",
        fieldName: "Executive Summary",
        fieldType: "Text",
        isNotReqSelected: "Y",
        isMandatorySelected: "N",
        placeholderValue: "Enter Executive Summary",
        canBeDeleted: "Y",
        orderPos:3,
        fieldStatus:"Created",
        fieldStatus_new:"Created"
    },
    {
        fieldId:"4",
        fieldName: "Instances",
        fieldType: "Table",
        isNotReqSelected: "Y",
        isMandatorySelected: "N",
        placeholderValue: "Enter Instance values",
        canBeDeleted: "Y",
        orderPos:4,
        fieldStatus:"Created",
        fieldStatus_new:"Created"
    },
    // Keep: Not to be deleted. It will be useful for old style of template - 28/10/26
    // {
    //     fieldId:"5",
    //     fieldName: "Risk/Impact",
    //     fieldType: "Dropdown Multiselect",
    //     isNotReqSelected: "Y",
    //     isMandatorySelected: "N",
    //     placeholderValue: "Enter Risk/Impact",
    //     canBeDeleted: "N",
    //     isFromRiskMaster: true,
    //     dropdownValues: [],
    //     orderPos: 5,
    //     fieldStatus:"Created",
    //     fieldStatus_new:"Created",
    //     isRiskMasterEnabled:"Y"
    // },
    // Keep: Not to be deleted. It will be useful for old style of template - 28/10/26
    {
        fieldId:"6",
        fieldName: "Suggestion",
        fieldType: "Text",
        isNotReqSelected: "Y",
        isMandatorySelected: "N",
        placeholderValue: "Enter Suggestion",
        canBeDeleted: "Y",
        orderPos:6,
        fieldStatus:"Created",
        fieldStatus_new:"Created"
    },
    
];

export const EXEC_TASK_FIELDS = [
    {
        "fieldId":"1",
        "fieldName":"Remarks",
        "fieldType":"Text",
        "isNotReqSelected":"N",
        "isMandatorySelected":"N",
        "placeholderValue":"Enter Remarks",
        "canBeDeleted":"Y",
        "addToPosition":"Right",
        "orderPos":1,
        "fieldStatus":"Created",
        "fieldStatus_new":"Created" 
    },
    {
        "fieldId":"2",
        "fieldName":"Risk/Impact",
        "fieldType":"Multi-select",
        "isNotReqSelected":"N",
        "isMandatorySelected":"N",
        "placeholderValue":"Enter Risk/Impact",
        "canBeDeleted":"N",
        "isRiskMasterEnabled":"Y",
        "addToPosition":"Right",
        "isFromRiskMaster":true,
        "dropdownValues":[],
        "orderPos":2,
        "fieldStatus":"Created",
        "fieldStatus_new":"Created"
    }
];

export const GENERAL_FIELDS = [
    {
        "fieldId":"1",
        "fieldName":"Text",
        "fieldType":"Text",
        "isNotReqSelected":"N",
        "isMandatorySelected":"Y",
        "placeholderValue":"Enter Text",
        "canBeDeleted":"N",
        "addToPosition":"Right",
        "orderPos":1,
        "fieldStatus":"Created",
        "fieldStatus_new":"Created"
    }
];

export const FOLLOW_UP_FIELDS = [
    {
        "fieldId":"1",
        "fieldName":"Remarks",
        "fieldType":"Text",
        "isNotReqSelected":"N",
        "isMandatorySelected":"Y",
        "placeholderValue":"Enter Remarks",
        "canBeDeleted":"N",
        "addToPosition":"Right",
        "orderPos":1,
        "fieldStatus":"Created",
        "fieldStatus_new":"Created"
    }
];
export const RESPONSE_FIELDS = [
    {
        "fieldId":"1",
        "fieldName":"Auditee Comment",
        "fieldType":"Text",
        "isNotReqSelected":"N",
        "isMandatorySelected":"Y",
        "placeholderValue":"Enter Comment",
        "canBeDeleted":"N",
        "addToPosition":"Right",
        "orderPos":1,
        "fieldStatus":"Active",
        "fieldStatus_new":"Active"
    },
    {
        "fieldId":"2",
        "fieldName":"Target",
        "fieldType":"Date",
        "isNotReqSelected":"N",
        "isMandatorySelected":"N",
        "placeholderValue":"Select date",
        "canBeDeleted":"N",
        "isTargetDate":"Y",
        "isTargetDateEnabled":"Y",
        "orderPos":2,
        "fieldStatus_new":"Active",
        "fieldStatus":"Active",
        "isSemiSelectField": true
    },
    {
        "fieldId":"3",
        "fieldName":"Responsibility",
        "fieldType":"Dropdown Multiselect",
        "isNotReqSelected":"N",
        "isMandatorySelected":"N",
        "dropdownValues":[],
        "placeholderValue":"Select users",
        "canBeDeleted":"N",
        "isResponsibilityField":"Y",
        "isResponsibilityFieldEnabled":"Y",
        "orderPos":3,
        "fieldStatus_new":"Active",
        "fieldStatus":"Active",
        "isSemiSelectField": true
    }
];
export const OBSERVATION_FIXED_FIELDS = {"assignRisk":"Y","assignRiskStatus":"Created","annexures":"Y","annexuresStatus":"Created","backups":"Y","backupsStatus":"Created"};
export const EXEC_TASKS_FIXED_FIELDS = {"assignRisk":"N","assignRiskStatus":"Created","annexures":"N","annexuresStatus":"Created","backups":"N","backupsStatus":"Created"};
export const FOLLOWUP_FIXED_FIELDS = {"backups":"N","backupsStatus":"Created"};
export const TASKS_FIXED_FIELDS = {"risk":"Y","riskStatus":"Created","fatal":"N","fatalStatus":"Created"};
export const RESPONSE_FIXED_FIELDS = {"backups":"N","backupsStatus":"Created"};